const EDUCATION_ADS_TEST_IDS = {
  // header has Archer ads
  ARTICLE_HEADER: 'edu_article_header',
  ARTICLE_INSTREAM: 'edu_article_instream_ad_',
  ARTICLE_RIGHT_RAIL: 'edu_article_rail',

  // header has Archer ads
  RANKINGS_HUB_HEADER: 'edu_header_rankingshub',
  RANKINGS_HUB_INSTREAM_1: 'edu_subsection_instream_rankingshub_1',
  RANKINGS_HUB_INSTREAM_2: 'edu_subsection_instream_rankingshub_2',

  RANKINGS_PAGE_FOOTER: 'edu_rankingpage_programs_footer_',
  // header has Archer ads
  RANKINGS_PAGE_HEADER: 'edu_rankingpage_programs_header_',
  RANKINGS_PAGE_PROGRAMS: 'edu_rankingpage_programs_',

  SCHOOL_INSTREAM: 'edu_school_instream',
  SCHOOL_RAIL: 'edu_school_rail',
};

export default EDUCATION_ADS_TEST_IDS;
